import { cn } from "@/lib/utils"

const TINT_WORDMARK_PATH =
  "M3.33757 1.67616V3.42264H4.87608V5.18151H3.33757V7.41107C3.33757 7.65054 3.40168 7.8384 3.52989 7.97465C3.6581 8.1109 3.82973 8.17902 4.04479 8.17902C4.31775 8.17902 4.55763 8.10883 4.76442 7.96845L5.34756 9.61584C5.14905 9.73971 4.9071 9.83467 4.62173 9.90073C4.33637 9.96679 4.03238 9.99982 3.70979 9.99982C2.83301 9.99982 2.15888 9.78512 1.6874 9.35573C1.21592 8.92633 0.98018 8.28637 0.98018 7.43584V5.18151H0L0 3.42264H0.98018L1.37039 1.67616H3.33757ZM21.1475 1.67616V3.42264H22.686V5.18151H21.1475V7.41107C21.1475 7.65054 21.2116 7.8384 21.3398 7.97465C21.468 8.1109 21.6397 8.17902 21.8547 8.17902C22.1277 8.17902 22.3676 8.10883 22.5743 7.96845L23.1575 9.61584C22.959 9.73971 22.717 9.83467 22.4317 9.90073C22.1463 9.96679 21.8423 9.99982 21.5197 9.99982C20.6429 9.99982 19.9688 9.78512 19.4973 9.35573C19.0258 8.92633 18.7901 8.28637 18.7901 7.43584V5.18151H17.8099V3.42264H18.7901L19.1803 1.67616H21.1475ZM8.62116 3.17492V9.88834H6.26376V3.17492H8.62116ZM14.3512 3.06344C15.1867 3.06344 15.8587 3.31117 16.3674 3.80662C16.8761 4.30208 17.1305 5.04939 17.1305 6.04856V9.88834H14.7731V6.43254C14.7731 5.51595 14.405 5.05765 13.6688 5.05765C13.2635 5.05765 12.9389 5.18977 12.6949 5.45401C12.4509 5.71826 12.3288 6.11462 12.3288 6.64311V9.88834H9.97145V3.17492H11.957L12.2172 3.90571C12.4819 3.63321 12.7962 3.42471 13.1601 3.2802C13.5241 3.13569 13.9211 3.06344 14.3512 3.06344ZM7.44315 0C8.16904 0 8.75749 0.559615 8.75749 1.24993C8.75749 1.94025 8.16904 2.49987 7.44315 2.49987C6.71726 2.49987 6.12881 1.94025 6.12881 1.24993C6.12881 0.559615 6.71726 0 7.44315 0Z"

export const TintMark = ({ className }: { className?: string }) => (
  <div
    aria-label="TINT"
    className={cn(
      "inline-flex items-center justify-center rounded-lg bg-[#111111] shadow-sm ring-1 ring-black/10",
      className
    )}
  >
    <svg
      viewBox="0 0 24 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="w-[62%]"
      aria-hidden="true"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d={TINT_WORDMARK_PATH}
        fill="url(#tint-mark-gradient)"
      />
      <defs>
        <radialGradient
          id="tint-mark-gradient"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="matrix(19.5129 4.56023 0.640584 11.5169 1.63878 1.34788)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF9711" />
          <stop offset="0.318477" stopColor="#FF538E" />
          <stop offset="0.642822" stopColor="#B662FF" />
          <stop offset="1" stopColor="#1FA2FC" />
        </radialGradient>
      </defs>
    </svg>
  </div>
)
